const selectColor: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#000000",
    buttonColor: "#F9BB00",
  },
  {
    color: "#2C698D",
    buttonColor: "#272643",
  },
  {
    color: "#B30000",
    buttonColor: "#002DB3",
  },
  {
    color: "#3C005A",
    buttonColor: "#3C005A",
  },
  {
    color: "#00515A",
    buttonColor: "#5A0028",
  },
  {
    color: "#68767D",
    buttonColor: "#495457",
  },
];

export default selectColor;
